// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/components/asset-list/asset-list.less
// module id = 3432
// module chunks = 0